<div class="form-row">
  <div class="form-group col-md-6">
    <input
      type="text"
      class="form-control mt-5"
      placeholder="{{ 'Letters' | localize }}"
      id="car-plate-letters"
      [(ngModel)]="letters"
      (ngModelChange)="onChange()"
    />
  </div>
  <div class="form-group col-md-6">
    <label for="car-plate-digits">{{ "CarPlate" | localize }}:</label>
    <input
      type="text"
      class="form-control"
      id="car-plate-digits"
      placeholder="{{ 'Digits' | localize }}"
      [(ngModel)]="digits"
      (ngModelChange)="onChange()"
    />
  </div>
</div>
